import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function NotePad(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "NotePad", children: [
    /* @__PURE__ */ jsx("path", { fill: theme.vars.palette.primary.light, d: "M16.04 36.585H5V14.507h22.078v22.078H16.04Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "M16.436 17.818a1.104 1.104 0 0 1-.96-1.656l4.625-8.147a1.104 1.104 0 0 1 1.457-.375 1.104 1.104 0 0 1 .42 1.512L17.353 17.3a1.103 1.103 0 0 1-.917.52Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "M19.958 12.41a2.705 2.705 0 1 0 0-5.41 2.705 2.705 0 0 0 0 5.41Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.secondary.main,
        d: "M20.454 22.234h-8.832a1.104 1.104 0 1 1 0-2.208h8.832a1.104 1.104 0 1 1 0 2.208Zm0 4.415h-8.832a1.104 1.104 0 1 1 0-2.207h8.832a1.104 1.104 0 1 1 0 2.207Zm0 4.416h-8.832a1.104 1.104 0 1 1 0-2.208h8.832a1.104 1.104 0 1 1 0 2.208Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: theme.vars.palette.primary.light, d: "M20.456 18.922h22.078V41H20.456V18.922Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "M31.89 22.234a1.104 1.104 0 0 1-.96-1.656l4.626-8.147a1.104 1.104 0 0 1 1.457-.375 1.103 1.103 0 0 1 .42 1.512l-4.626 8.147a1.104 1.104 0 0 1-.917.519Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.primary.dark,
        d: "M35.414 16.825a2.705 2.705 0 1 0 0-5.41 2.705 2.705 0 0 0 0 5.41Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.secondary.main,
        d: "M35.91 26.65h-8.83a1.104 1.104 0 1 1 0-2.209h8.83a1.104 1.104 0 0 1 0 2.208Zm0 4.415h-8.83a1.104 1.104 0 1 1 0-2.208h8.83a1.104 1.104 0 0 1 0 2.208Zm0 4.415h-8.83a1.104 1.104 0 1 1 0-2.207h8.83a1.104 1.104 0 0 1 0 2.207Z"
      }
    )
  ] });
}
NotePad.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "NotePad"
};
validateTidalLicense();
export {
  NotePad
};
//# sourceMappingURL=NotePad.js.map
